import { useLocalSearchParams, useRouter } from 'expo-router';
import { useQuery } from 'urql';
import OwnershipTransferPeople from '@/components/Custom/OwnershipTransferPeople';
import ContentBoundary from '@/components/UI/ContentBoundary';
import EmptyPlaceholder from '@/components/UI/EmptyPlaceholder';
import { graphql } from '@/gql/graphql';
import useUserId from '@/hooks/useUserId';

const GetOrganizationTransferContext = graphql(`
  query GetOrganizationTransferContext($organizationId: uuid!) {
    event_by_pk(id: $organizationId) {
      id
      title
      event_type
      owner_id
    }
  }
`);

export default function OrganizationTransfer() {
  const { organizationId } = useLocalSearchParams<{
    organizationId: string;
  }>();
  const userId = useUserId();
  const { push } = useRouter();

  const [{ data, fetching, error }, refresh] = useQuery({
    query: GetOrganizationTransferContext,
    variables: { organizationId },
  });
  const organization = data?.event_by_pk;
  const canTransfer =
    organization &&
    organization.owner_id === userId &&
    organization.event_type === 'organization';

  return (
    <ContentBoundary
      data={canTransfer ? organization : null}
      loading={fetching}
      error={error}
      onRetry={() => refresh({ requestPolicy: 'network-only' })}
      empty={<EmptyPlaceholder message="Ownership transfer is unavailable." />}
    >
      {(organization) => (
        <OwnershipTransferPeople
          title={organization.title || 'ownership'}
          where={{
            organization_transfer_recipient: {
              organization_id: { _eq: organizationId },
            },
            id: { _neq: userId },
          }}
          onSelect={(person) =>
            push({
              pathname:
                '/organization/[organizationId]/edit/transfer/[transferId]',
              params: { organizationId, transferId: person.id },
            })
          }
        />
      )}
    </ContentBoundary>
  );
}
